import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import {
  CtaSectionComponent,
  CustomerLogoSectionComponent,
  TestimonialsSectionComponent,
} from '@app/widgets';
import { COMPARE_IONIC_APPFLOW_FAQS } from '../../constants';
import { CompareIonicAppflowAdvantagesSectionComponent } from '../compare-ionic-appflow-advantages-section/compare-ionic-appflow-advantages-section.component';
import { CompareIonicAppflowFaqSectionComponent } from '../compare-ionic-appflow-faq-section/compare-ionic-appflow-faq-section.component';
import { CompareIonicAppflowHeroSectionComponent } from '../compare-ionic-appflow-hero-section/compare-ionic-appflow-hero-section.component';
import { CompareIonicAppflowTableSectionComponent } from '../compare-ionic-appflow-table-section/compare-ionic-appflow-table-section.component';

@Component({
  selector: 'app-compare-ionic-appflow',
  imports: [
    CompareIonicAppflowHeroSectionComponent,
    CustomerLogoSectionComponent,
    CompareIonicAppflowAdvantagesSectionComponent,
    CompareIonicAppflowTableSectionComponent,
    TestimonialsSectionComponent,
    CompareIonicAppflowFaqSectionComponent,
    CtaSectionComponent,
  ],
  templateUrl: './compare-ionic-appflow.component.html',
  styleUrl: './compare-ionic-appflow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareIonicAppflowComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setTitle(
      'The #1 Alternative to Ionic Appflow: Capawesome Cloud',
    );
    this.metaService.setKeywords([
      'Ionic Appflow alternative',
      'Appflow replacement',
      'Capacitor CI/CD',
    ]);
    this.metaService.setDescription(
      'Compare Capawesome Cloud with Ionic Appflow. Discover why teams choose Capawesome Cloud for live updates, native builds, and app store publishing - better pricing, features, and support.',
    );
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Capawesome Cloud vs Ionic Appflow',
        'Compare Capawesome Cloud with Ionic Appflow for live updates, native builds, and app store publishing.',
        'https://cloud.capawesome.io/compare/ionic-appflow/',
      ),
      JsonLdService.buildFaqSchema(COMPARE_IONIC_APPFLOW_FAQS),
    ]);
  }
}
